import { render, staticRenderFns } from "./CollisionHistoryTable.vue?vue&type=template&id=eef20e7c&scoped=true"
import script from "./CollisionHistoryTable.vue?vue&type=script&lang=js"
export * from "./CollisionHistoryTable.vue?vue&type=script&lang=js"
import style0 from "./CollisionHistoryTable.vue?vue&type=style&index=0&id=eef20e7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef20e7c",
  null
  
)

export default component.exports